// extracted by mini-css-extract-plugin
export default {"header":"WelcomingTopBar_header__G7+Eh","time":"WelcomingTopBar_time__lH6Ht"};